/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invalid_CredentialsInputs */

const fr_error_invalid_credentials = /** @type {(inputs: Error_Invalid_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email ou mot de passe incorrect. Vérifiez-les ou réinitialisez le mot de passe.`)
};

const en_error_invalid_credentials = /** @type {(inputs: Error_Invalid_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect email or password. Check them or reset your password.`)
};

/**
* | output |
* | --- |
* | "Incorrect email or password. Check them or reset your password." |
*
* @param {Error_Invalid_CredentialsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_invalid_credentials = /** @type {((inputs?: Error_Invalid_CredentialsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invalid_CredentialsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_invalid_credentials(inputs)
	return fr_error_invalid_credentials(inputs)
});